require('../../modules/core.regexp.escape');
module.exports = require('../../modules/_core').RegExp.escape;


/*****************
 ** WEBPACK FOOTER
 ** /mnt/jenkins/jobs/master/workspace/~/core-js/fn/regexp/escape.js
 ** module id = 295
 ** module chunks = 12
 **/